module.exports = __webpack_public_path__ + "static/media/edit.265786fd.png";